import React, { Component } from "react";
import { Button, Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import "./notFound.scss";

export default class NotFound extends Component {
  render() {
    return (
      <Container className="not-found">
        <p className="not-found-text">404</p>
        <h2>page not found </h2>
        <h3>Sorry, the page you're looking for is not exist</h3>
        <Link to="/" className=" btn btn-secondary link-to-home">
          Home
        </Link>
      </Container>
    );
  }
}
